export enum EDriverScoreKind {    
    ProfileFilled,
    RegistrationAtLoadingPoint,
    RegistrationAtUnloadingPoint,
    DeliveryFinished
}